<template>

<!--   <el-card shadow="hover">  -->

    <popup
        :heading="(isAdd ? 'Add' : (isView ? 'View' : 'Edit')) + ' Checklist' + (isAdd ? '' : formData.name + (formData.category ? ' (' + formData.category + ')' : ''))"
        :button-style="isAdd ? 'warning' : 'text'"
        round
        :button-size="isAdd ? 'mini' : 'text'"
        :button-text="isAdd ? 'Add' :  (isView ? 'View' : 'Edit')"
        :button-icon="isAdd ? 'fa fa-plus' :  (isView ? 'fa fa-eye' : 'fa fa-edit')"
        :show-save="!isView"
        :disableButton="!isView && !canAccess('maintenance')"
        @save="onSave"
        @cancel="onCancel">

    <el-form label-position="left" label-width="11em">

      <el-tabs type="border-card">

        <el-tab-pane label="Checklist">
          <el-row :gutter="16">

            <el-col :sm="24" :md="12" :lg="8">
              <select-input v-if="editing" label="" placeholder="Select Category..." v-model='formData.category' :list="categoryOption" filterable create :disabled="!editing || !isSiteManager" />
            </el-col>

            <el-col :sm="24" :md="12" :lg="8">
              <text-input v-if="editing" label="" placeholder="Checklist Name..." v-model="formData.name" :disabled="!editing || !isSiteManager" />
            </el-col>

            <el-col :sm="24" :md="12" :lg="8">
              <check-box
                v-if="editing || formData.photoRequired"
                v-model="formData.photoRequired"
                :disabled="!editing || !isSiteManager">
                Photo Required <b class="success-text" :class="formData.photoRequired? 'fa fa-camera' : ''"></b>
              </check-box>
            </el-col>

          </el-row>

          <el-row v-if="isSite" :gutter="8">
            <el-col :span="12">

              <select-input
                v-model="formData.status"
                placeholder="Select Status..."
                :list="ticketOptions"
                :disabled="!editing" />

            </el-col>

            <el-col v-if="formData.status ==='Finished'" :span="12">
              <el-rate
                :min="1"
                :max="formData.gradingMax"
                v-model="formData.grading"
                :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
                :disabled="!editing"
              />
            </el-col>

            <el-col v-if="formData.notesToWorkers || editing" :span="24">
              <html-input label="Notes To Workers" v-model="formData.notesToWorkers" :disabled="!editing || isTelco()"  />
            </el-col>

          </el-row>

          </el-tab-pane>


          <el-tab-pane v-if="formData.photoRequired && !isAdd && isSite" label="Upload Photos" lazy>

            <el-row class="padded" :gutter="12">
              <el-col :span="24">
                <el-card shadow="hover">
                  <files-panel title="Before" :max-files="1" type="site" :id="rowData.site_id" process="workflow-before" :process-id="formData.id" :disabled="isView" hide-carousel />
                </el-card>
              </el-col>

              <el-col :span="24">
                <el-card shadow="hover">
                  <files-panel title="After" :max-files="1" type="site" :id="rowData.site_id" process="workflow-after" :process-id="formData.id" :disabled="isView" hide-carousel />
                </el-card>
              </el-col>

            </el-row>

          </el-tab-pane>



          <el-tab-pane  label="Service Level Agreement (SLA)">

            <el-row :gutter="8">
              <el-col :sm="24" :md="12" :lg="6">

                <integer-input v-if="editing"
                    label="Workforce Estimated"
                    placeholder="Workforce (est.)"
                    v-model="formData.workforceReq"
                    :disabled="!editing || !isSiteManager" />

              </el-col>
            </el-row>

            <el-row :gutter="8">
              <el-col :sm="24" :md="12" :lg="6">
                <integer-input
                  label="Setup Task Time (est.)"
                  placeholder="Setup Task Time"
                  v-model="formData.setupTime"
                  :suffix="disabled ? formData.setupTimeUnits : ''"
                  prefix="fa fa-clock text-muted"
                  :is-prefix-icon="true"
                  :disabled="!editing || !isSiteManager" />
              </el-col>

              <el-col :sm="24" :md="12" :lg="6">
                <select-input  label="Setup Time Units"
                  v-model="formData.setupTimeUnits"
                  :list="unitsOption"
                  :disabled="!editing || !isSiteManager" />
              </el-col>

            </el-row>

            <el-row :gutter="8">

              <el-col :sm="24" :md="12" :lg="6">
                <integer-input
                  label="Task Time (est.)"
                  placeholder="Task Time"
                  v-model="formData.taskTime"
                  :suffix="disabled ? formData.taskUnits : ''"
                  prefix="fa fa-clock text-muted"
                  :is-prefix-icon="true"
                  :disabled="!editing || !isSiteManager" />
              </el-col>

              <el-col :sm="24" :md="12" :lg="6">
                <select-input  label="Time Units" v-model="formData.taskUnits" :list="unitsOption"  :disabled="!editing || !isSiteManager" />
              </el-col>


            </el-row>
          </el-tab-pane>


          <el-tab-pane v-if="canAccess('maintenance|project|management') && (formData.remarks || (editing && isSiteManager))" label="Remarks">
            <el-col v-if="formData.remarks || editing" :span='24'>
              <html-input label="Remarks" v-model="formData.remarks" :disabled="!editing || !isSiteManager" />
            </el-col>
          </el-tab-pane>

<!--
          <el-tab-pane label="Form Builder">

            <el-col :span="24">

              <form-builder
                  v-if="(formData.dataType && formData.dataType.toLowerCase() === 'form') || editing"
                  title="Form"
                  title-style='b'
                  table-style='bg-success-lighten-3'
                  v-model="formData.formTemplate" />

            </el-col>

      </el-tab-pane>
-->
    </el-tabs>

</el-form>

</popup>
<!-- </el-card>  -->

</template>

<script>

import WorkflowMixins from '@/mixins/WorkflowMixins'

import FilesPanel from '@/components/atoms/files/FilesPanel'
import FormBuilder from '@/components/atoms/forms/FormBuilder'

export default {
  mixins: [WorkflowMixins],

  components: {
    FilesPanel,
    FormBuilder
  },

  props: {
    rowData: {
      type: Object,
      required: true
    },

    isAdd: {
      type: Boolean,
      default: false
    },

    isSite: {
      type: Boolean,
      default: false
    },

    isView: {
      type: Boolean,
      default: false
    },

    parentId: {
      type: Number,
      default: null
    },

    siteId: {
      type: Number,
      default: null
    },

    workflowId: {
      type: Number,
      default: null
    }

  },


  methods: {

    onSave () {

      if (!this.formData.parent_id && (this.isSite ? !this.formData.site_id || !this.formData.workflow_id : true)) {
        this.$notify({
          type: 'warning',
          title: 'Warning',
          message: 'No Parent ID' + (this.isSite ? ' or Site ID or Workflow ID' : '') + '. Can\'t add.'
        })
        return
      }

      if (this.formData.name) {
        this.saveForm(this,
          this.url + '/checklist' + (this.isAdd ? '/new/' + this.parentId : '/'), (this.isAdd ? null : this.formData.id),
           this.formData,
           (this.isSite ? 'Site ' : '') + 'Checklist',
           null,
           null,
           true,
           (this.isSite
             ? [this.CHECKLIST_TABLE_REF, this.SITE_WORKFLOW_TABLE_REF]
             : [this.CHECKLIST_TABLE_REF, this.WORKFLOW_TABLE_REF]))
      } else {
        this.$notify({
          type: 'warning',
          title: 'Warning',
          message: 'Please input a checklist name'
        })
      }

    },

    onCancel () {
      this.editing = false
    },


    onEdit () {
      this.editing = true
    },

    onAdd () {
      this.editing = true
    }

  },

  watch: {
    rowData: function (data) {
      this.formData = data
    }
  },


  data () {
    return {
      url: this.isSite ? 'workflow/sites' : 'workflow',
      editing: !this.isView,
      formData: this.rowData
    }
  },


  created () {

    if (!this.rowData) {
      if (this.isSite) {
        this.formData = this.getTableStruct('site_workflow')
      } else {
        this.formData = this.getTableStruct('workflow')
      }
    }

    if (this.isAdd) {

      if (this.parentId) {
        this.formData.parent_id = this.parentId
      }

      if (this.isSite) {

        if (this.workflowId) {
          this.formData.workflow_id = this.workflowId
        }

        if (this.siteId) {
          this.formData.site_id = this.siteId
        }

      } else {
        delete this.formData.site_id
        delete this.formData.workflow_id
      }  // eof: isSite
    }
  }

}
</script>
